import { render, staticRenderFns } from "./StudentHomework.vue?vue&type=template&id=97c9cb0a&"
import script from "./StudentHomework.vue?vue&type=script&lang=js&"
export * from "./StudentHomework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports